import React from 'react';

export const ShimmerBanner = () => {
  return (
    <>
      <div className="shine shimmer-logo" />
      <div>
        <div className="shine shimmer-title" />
      </div>
      <div>
        <div className="shine shimmer-line" />
      </div>
      <div>
        <div className="shine shimmer-line" />
      </div>
      <div>
        <div className="shine shimmer-title" />
      </div>
    </>
  );
};
